// extracted by mini-css-extract-plugin
export default {"card":"style_card__bf-Py","cardFull":"style_cardFull__E8Y6S"};